/**
 * Reversi の TypeScript 表現 (mixed-engine の serde 形と一致)。
 */

export type ReversiPiece = 'Empty' | 'Black' | 'White';
export type Side = 'First' | 'Second';

export interface ReversiState {
  board: ReversiPiece[][];
  side: Side;
  passes: number;
}

export type ReversiMove = 'Pass' | { Place: { row: number; col: number } };

export function isPlace(m: ReversiMove): m is { Place: { row: number; col: number } } {
  return typeof m === 'object' && 'Place' in m;
}

export function legalKey(row: number, col: number): string {
  return `${row}-${col}`;
}
